<template>
  <b-container>
    <b-card class="shadow-sm metrics-card">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="mb-0">Métricas</h4>
        <UpdateMetrics @refresh="fetchData" />
      </div>

      <b-row>
        <b-col md="4" v-for="(label, key) in gatewaysMap" :key="key">
          <b-card class="gateway-card">
            <h5 class="gateway-title">{{ label }}</h5>

            <div
              v-for="(item, index) in metrics[key]"
              :key="key + index"
              class="metric-item"
            >
              <div>
                <small>Quantidade</small>
                <div class="metric-value">
                  {{ formatQuantity(item.quantity) }}
                </div>
              </div>

              <div>
                <small>Valor</small>
                <div class="metric-value">
                  {{ formatCurrency(item.value) }}
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { BContainer, BCard, BRow, BCol } from "bootstrap-vue";
import UpdateMetrics from './UpdateMetrics.vue';
import GatewayExpenseService from "@/service/gateway-expense"

export default {
  name: 'MetricsDisplay',
  components: { BContainer, BCard, BRow, BCol, UpdateMetrics },
  data() {
    return {
      isLoading: false,
      metrics: {
        gsurf: [],
        paygo: [],
        veripag: []
      },
      gatewaysMap: {
        veripag: 'Veripag',
        paygo: 'Paygo',
        gsurf: 'Gsurf'
      }
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        const response = await GatewayExpenseService.getMetrics();
        const data = response?.data || response;

        this.metrics = {
          veripag: data.veripag || [],
          gsurf: data.gsurf || [],
          paygo: data.paygo || [],
        };
      } catch (error) {
        console.error("Erro ao carregar métricas:", error);
      } finally {
        this.isLoading = false;
      }
    },
    formatQuantity(value) {
      return new Intl.NumberFormat('pt-BR').format(value);
    },
   formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
      }).format(value);
    }
  },
}
</script>

<style scoped>
.metrics-card {
  border: none;
}

.gateway-card {
  border: 1px solid #e6e6e6;
  transition: all 0.2s ease;
}

.gateway-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.08);
}

.gateway-title {
  font-weight: 600;
  margin-bottom: 15px;
  color: #2e2c6c;
}

.metric-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.metric-item:last-child {
  border-bottom: none;
}

.metric-value {
  font-weight: 600;
  font-size: 15px;
}
</style>